<div
  class="root-container"
  [ngClass]="{
    'theme-white': theme === 'white',
    'theme-dark': theme === 'dark'
  }"
>
  <ng-container *ngIf="!useDefaultHtmlInput">
    <div role="button" class="button" (click)="decrement()">
      <i class="fa fa-minus"></i>
    </div>
    <div class="input-container">
      <input
        #inputEl
        [class.disabled]="disabled"
        type="number"
        [ngModel]="value"
        (ngModelChange)="onValueChange($event)"
        pattern="pattern"
        [maxlength]="maxLength"
        [minlength]="minLength"
        [attr.disabled]="contentEditable ? null : 'disabled'"
      />
      <span class="sign" [hidden]="!sign">{{ sign }}</span>
    </div>
    <div class="button" role="button" (click)="increment()">
      <i class="fa fa-plus"></i>
    </div>
  </ng-container>
  <ng-container *ngIf="useDefaultHtmlInput">
    <div class="normal-input">
      <input
        #inputEl
        type="number"
        [ngModel]="value"
        (ngModelChange)="onValueChange($event)"
        (keypress)="onKeyPress($event)"
        pattern="pattern"
        step="{{ step }}"
        max="{{ maxLength }}"
        min="{{ minLength }}"
        [attr.disabled]="contentEditable ? null : 'disabled'"
      />
      <span class="sign" [hidden]="!sign">{{ sign }}</span>
    </div>
  </ng-container>
</div>
